import { io } from "socket.io-client";

//const socket = io("http://mega-games.ir:5002", {

  const socket = io ();
// const socket = io  ("http://localhost:5002",{transports:['websocket'],reconnectionAttempts:5,timeout:5000});
//const socket = io   ("http://localhost:5002", { autoConnect: true,});

export default socket;
